import React from 'react';
import 'twin.macro';
import Helmet from 'react-helmet';

import { Container } from '../atoms';

const ReviewBlock = () => {
  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          href="https://widget.reviews.co.uk/combined/style.css?RUKcarousel"
        />
        <script src="https://widget.reviews.co.uk/combined/dist.js?RUKcarousel" />
        <div id="ReviewsWidget" />
        <script async src="/js/scripts.js" />
      </Helmet>
      <Container>
        <div tw="mb-10 ">
          <div id="ReviewsWidget" />
        </div>
      </Container>
    </>
  );
};

export default ReviewBlock;
